<template>
    <div class="content_module" ref="modules">
         <div class="back">WEINVENT</div>
         <div class="content">
            <p class="title1">产品中心</p>
            <p class="title2">PRODUCT CENTER</p>
            <p class="title3"><span></span></p>
            <div v-for="$row in product_center.items" class="content_left" :class="{blue:$row.back_show}">
                <img ref="contentImg" :src="$row.img_src" />
                <div :ref="$row.ref" class="title">{{$row.name}}<span style="color:#1745a5;">{{$row.value}}</span></div>

                <router-link v-for="(item,idx) in $row.item_list" :to="item.url" :key="idx">
                <div ref="contentItem" class="active">
                    <span>{{item.name}}</span>
                    <button>了解更多</button>
                </div>
                </router-link>

                <router-link class="button_more" :to="$row.more_url">
                <button class="more" ref="contentMore">更多产品</button>
                </router-link>
            </div>
         </div>
    </div>
</template>

<script>
export default {
  name: 'product-center',
  props:["product_center"],
  data () {
    return {
    }
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.contentImg,topReveal)
    self.$scroll().reveal(self.$refs.contentLeft,leftReveal)
    self.$scroll().reveal(self.$refs.contentRight,rightReveal)
    self.$scroll().reveal(self.$refs.contentItem,fooReveal)
    //self.$scroll().reveal(self.$refs.contentMore,fooReveal)
  },
}
</script>

<style scoped>
@import '../../../static/css/common.css';

.content_module .content .content_left {
    width: 50%;
    height:552px;
    background-color:#ffffff;
    box-shadow: -10px 0 20px rgba(35,24,21,0.15);
    margin-top:100.5px;
    float:left;
    margin-bottom:90px;
    position:relative;
    text-align: center
}

.content_module .content .content_left img{
    width:145.5px;
    height:141px;
    margin-top:-70.5px;
}

.content_module .content .content_left .title{
    font-size:18px;
    color:#070707;
    margin-top:30px;
    margin-bottom:50px;
    font-weight:600;
}

.content_module .content .content_left .active{
    font-size:16px;
    color:#070707;
    margin:0 40px;
    margin-bottom:35px;
    text-align:left;
}

.content_module .content .blue{
    background-color:#f2f2f2;
    box-shadow: 10px 0 20px rgba(35,24,21,0.15);
}

.content_module .content .content_left .button_more{
    width:100%;
    display:flex;
    justify-content:center;
}
.content_module .content .content_left .more{
    font-size:16px;
    color:#1745a5;
    border:0px solid #1745a5;
    box-shadow: 0 0 10px rgba(35,24,21,0.15);
    border-radius:20px;
    background-color:#fff;
    padding:1px 10px;
    height:40px;
    width:150px;
    position:absolute;
    bottom:-20px;
    margin:0 auto;
    line-height:40px;
    cursor:pointer;
}
.content_module .content .content_left .more:hover{
    background-color:#2d8cf0;
    color:#fff;
}
.content_module .content .content_left .more:active{
    background-color:#0d50bf;
    color:#fff;
}
.content_module .content .content_left .active button{
    font-size:12px;
    color:#1745a5;
    border:1px solid #1745a5;
    border-radius:5px;
    float:right;
    background-color:#fff;
    padding:0 10px;
    height:30px;
}
.content_module .content .content_left .active span{
    max-width: 70%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.content_module .content .content_left .active:hover
{
    color: #2d8cf0;
}
.content_module .content .content_left .active:hover button
{
    color: #fff;
    background-color: #2d8cf0;
    cursor: pointer;
    border: 0;
}
.content_module .content .content_left .active:active
{
    color: #0d50bf;
}
.content_module .content .content_left .active:active button
{
    color: #fff;
    background-color: #0d50bf;
    cursor: pointer;
    border: 0;
}
@media screen and (max-width: 788px) {
    .content_module .content{
        display:flex;
        justify-content:center;
        flex-wrap:wrap;
    }
    .content_module .content .content_left {
        width: 70%;
        box-shadow: 0 0 20px rgba(35,24,21,0.15);
        text-align: center;
        min-width: 330px;
    }

    .content_module .content .content_left .active span{
        max-width: 70%;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/product_center.vue